<script setup>
import {computed, defineProps, onMounted} from "vue";
import {useStore} from "vue2-helpers/vuex";
import VueMultiselect from "vue-multiselect";

const props = defineProps(['value']);
const emit = defineEmits('input');

const store = useStore();

const tags = computed({
    get: () => props.value,
    set: (value) => {
        emit('input', value);
    }
});

onMounted(() => {
    store.dispatch('fetchTags');
})
</script>

<template>
    <VueMultiselect
        v-model="tags"
        :multiple="true"
        :options="store.getters.tagsList"
        select-label=""
        deselect-label=""
        placeholder="Type to search your tags"
        label="name"
        track-by="name"
        class="multiselect-mid selectbox selectbox-mid"
    />
</template>

<style scoped>

</style>
